import { Directive, Input, HostBinding, HostListener } from '@angular/core';

@Directive({
  standalone: false,
    selector: 'img[default]',
})

export class ImageDefaultDirective {
    private originalSrc!: string;
    private hasError: boolean;

    @Input('src') set src(value: string) {
        if (!value) { return; }
        this.setSource(value);
    }
    @Input() default: string;

    @HostBinding('src') get currentSrc(): string {
        if (this.hasError) {
            return this.default;
        } else {
            return this.originalSrc;
        }
    }

    setSource(source: string) {
        if (source === this.originalSrc) { return; }

        this.hasError = false;
        this.originalSrc = source;
    }

    @HostListener('error')
    failure() {
        this.hasError = true;
    }
}
